import { Box, Chip, CircularProgress } from '@mui/material';
import { get } from 'lodash';
import { MouseEvent } from 'react';
import { Link, RaRecord, useGetMany, useRecordContext } from 'react-admin';

import { useResourceBasePath } from '@sh4res/bo-common/hooks';
import { buildLink } from '@sh4res/bo-common/utils/build_link';

interface ContractRecord extends RaRecord {
  contract_number: string;
}

export interface ContractsFieldProps {
  source: string;
  label?: string;
  record?: RaRecord;
  'data-testid'?: string;
}

export const ContractsField = ({
  source,
  record: recordFromProps,
  'data-testid': dataTestId,
}: ContractsFieldProps) => {
  const recordFromContext = useRecordContext();
  const record = recordFromProps || recordFromContext;
  const contractIds = get(record, source);
  const resourceBasePath = useResourceBasePath();

  const {
    data: contracts,
    isLoading,
    error,
  } = useGetMany<ContractRecord>(
    `${resourceBasePath}contracts`,
    { ids: contractIds || [] },
    { enabled: !!record && !!contractIds && contractIds.length > 0 },
  );

  return (
    <Box
      sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}
      data-testid={dataTestId ?? 'BoContractsField'}>
      {isLoading && <CircularProgress size={20} />}
      {error && <Box color="error.main">Error loading affiliations</Box>}
      {!isLoading && !error && (!contracts || contracts.length === 0) && <span>-</span>}
      {!isLoading &&
        !error &&
        contracts &&
        contracts.map((contract) => (
          <Chip
            key={contract.id}
            label={contract.contract_number || `ID: ${contract.id}`}
            component={Link}
            to={buildLink(`${resourceBasePath}contracts`, 'show', contract.id)}
            clickable
            target="_blank"
            onClick={(event: MouseEvent) => event.stopPropagation()}
          />
        ))}
    </Box>
  );
};
